import { useRef } from 'react';
import { useBannerAnimation } from './useBannerAnimation';
import './HeroBanner.css';

const mediaRoot = `${process.env.PUBLIC_URL || ''}/media/goat-to-shawl-v2`;

export default function HeroBanner() {
  const videoRef = useRef<HTMLVideoElement>(null);
  const artRef = useRef<HTMLDivElement>(null);
  const { rendition, started } = useBannerAnimation(videoRef, artRef);
  const mobile = rendition === 'mobile';
  return (
    <section className="banner" aria-labelledby="hero-title">
      <div className="banner__inner">
        <div className="banner__content">
          <h1 className="banner__title" id="hero-title">
            Authentic Shawls
          </h1>
          <p className="banner__subtitle">Handcrafted with tradition, worn with pride</p>
          <a className="banner__cta" href="#product-gallery">
            Explore the collection
          </a>
        </div>
        <div className="banner__art" ref={artRef}>
          <div className="banner__media" aria-hidden="true">
            <video
              key={rendition || 'static'}
              ref={videoRef}
              muted
              playsInline
              preload="metadata"
              poster={rendition ? `${mediaRoot}-${rendition}-poster.webp` : undefined}
              width={mobile ? 768 : 1280}
              height={mobile ? 576 : 720}
            >
              {rendition && (
                <>
                  <source src={`${mediaRoot}-${rendition}.webm`} type="video/webm" />
                  <source src={`${mediaRoot}-${rendition}.mp4`} type="video/mp4" />
                </>
              )}
            </video>
            <picture className={`banner__poster${started ? ' banner__poster--hidden' : ''}`}>
              <source
                media="(max-width: 900px)"
                srcSet={`${mediaRoot}-mobile-poster.webp`}
                width="768"
                height="576"
              />
              <img src={`${mediaRoot}-desktop-poster.webp`} width="1280" height="720" alt="" />
            </picture>
          </div>
        </div>
      </div>
    </section>
  );
}
